<template>

 <b-card
        :title="this.translations.merge[this.lang]"
        @cancel="$emit('cancel')"
        @submit="submitMerge()"
      
        :disabled="false"
        :submit-text="{ el: 'Έναρξη Συγχώνευσης', en: 'Start Merge', it: 'Iniziare l\'unione' }"
        :cancel-text="{ el: 'Ακύρωση', en: 'Cancel', it: 'Cancella' }"
    >
  
            <v-col cols="12" class="pr-2">
                {{ this.translations.mergeUserId[this.lang] + ': ' }}
                {{ absorbMobile }}
                <b-text-field 
                    :label="this.translations.mobile[this.lang] + this.translations.absorb[this.lang]"
                    v-model="absorbMobile"
                    v-mask="'##########'"
                ></b-text-field>
            </v-col>
            
            <v-col cols="12" class="pr-2">
                {{ this.translations.into[this.lang]+': ' }}
                <b-text-field
                    :label="this.translations.mobile[this.lang] + this.translations.keep[this.lang]"
                    v-model="keepMobile"
                    v-mask="'##########'"
                ></b-text-field>
            </v-col>
              <v-col cols="12" class="pr-2">
                *{{ this.translations.mergeProcess24h[this.lang] }}
            </v-col>
    </b-card>
</template>

<script>
import { mdiClose } from "@mdi/js";

import validators from "@/utils/validators/loyaltyPanel/customers";
import debounce from "lodash/debounce";
import translations from "@/utils/translations/loyaltyPanel/customers";
import { mapState, mapActions, mapGetters, mapMutations } from "vuex";

export default {
    name: "UserMergeDialog",
    mixins: [validators, translations],
    data: () => ({
        icons: { mdiClose },
        mobile: null,
    }),

    computed: {
        lang() {
            return this.$route.params.lang;
        },

        absorbMobile: {           
             get() {
                return this.mobile;
            },

            set(val) {
                if( /^\d+$/.test(val)) this.mobile = val
            },
        },

        keepMobile: {           
             get() {
                return this.mergeDialogMobile;
            },

            set(val) {
                if( /^\d+$/.test(val)) this.setMergeDialogMobile(val)
            },
        },
        
        ...mapState("loyaltyPanel/customers", ["mergeDialogMobile"]),
    },
     methods: {
          ...mapMutations("loyaltyPanel/customers", ["setMergeDialogMobile", ]),
           ...mapActions("loyaltyPanel/customers", [
            "mergeUsers",
        ]),
          async submitMerge() {
            this.$emit('merge', {absorb_user_account_mobile: this.absorbMobile, keep_user_account_mobile: this.keepMobile});
          }
          
     }

};
</script>
